import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ClientContactService extends Service {
	constructor(injector: Injector) {
		super("ClientContact", injector);
	}

	// API
	getContactByParentId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetContactsByClientId/${id}`);
	}
}